import { formatDate } from '@/portainer/filters/filters';

import { Matcher, SilencedAlertRow, SilencedAlertsResponse } from './types';

export function transformToAlertRuleRow(
  silencedAlertsResponse: SilencedAlertsResponse
): Array<SilencedAlertRow> {
  // Flatten the response structure and extract all silenced alerts
  const allSilencedAlerts = silencedAlertsResponse.flatMap(
    (response) => response.Payload || []
  );

  function findMatcherValue(
    matchers: Matcher[],
    name: string,
    fallback: string
  ): string {
    return matchers.find((matcher) => matcher.name === name)?.value || fallback;
  }

  return allSilencedAlerts.map((silencedAlert) => ({
    id: silencedAlert.id,
    startsAt: formatDate(new Date(silencedAlert.startsAt)),
    endsAt: formatDate(new Date(silencedAlert.endsAt)),
    createdBy: silencedAlert.createdBy,
    comment: silencedAlert.comment,
    alertRule: findMatcherValue(silencedAlert.matchers, 'alertname', '-'),
    environmentName: findMatcherValue(
      silencedAlert.matchers,
      'portainer_environment_name',
      '-'
    ),
    environmentGroupName: findMatcherValue(
      silencedAlert.matchers,
      'portainer_environment_group_name',
      'Unassigned'
    ),
    status: silencedAlert.status.state,
    canDelete: ['active', 'pending'].includes(silencedAlert.status.state),
  }));
}
